module.exports = __webpack_public_path__ + "media/images/vector-22@2x-bd38b692c4c4fa8d064bce6030d632c6.png";